import { Email, Phone } from "@mui/icons-material";
import type { ProfileDisplayProps } from "../types";
import { useTranslation } from "react-i18next";
import { PORTAL_FORM_READONLY_CONTROL_CLASS } from "@constants/portalUiTheme";

const ProfileDisplay: React.FC<ProfileDisplayProps> = ({ phoneNumber, emailAddress }) => {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col gap-3">
			<div className={PORTAL_FORM_READONLY_CONTROL_CLASS}>
				<Phone fontSize="small" className="mr-2 text-gray-500" />
				<span className="truncate">{phoneNumber || t("psdaCommon.common.notAvailable")}</span>
			</div>

			<div className={PORTAL_FORM_READONLY_CONTROL_CLASS}>
				<Email fontSize="small" className="mr-2 text-gray-500" />
				<span className="truncate">{emailAddress || t("psdaCommon.common.notAvailable")}</span>
			</div>
		</div>
	);
};

export default ProfileDisplay;
